var _defs, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.68 46.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.84,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.48,
    cy: 2.43,
    r: 1.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.2,
    cy: 2.43,
    r: 1.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.12,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,8.32c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.12,8.32c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.3,10.49c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.3,6.14c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,8.32c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.84,8.32c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.66,10.49c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.02,10.49c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.66,6.14c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.02,6.14c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.48,
    cy: 11.15,
    r: 1.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,8.32c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.84,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.56,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.56,8.32c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.38,10.49c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.38,6.14c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.2,
    cy: 11.15,
    r: 1.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,8.32c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,3.96c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,17.03c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.12,17.03c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.3,14.85c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.12,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,17.03c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,17.03c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.48,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.56,17.03c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.38,14.85c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,17.03c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.56,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,12.67c.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53-1.53.68-1.53,1.53.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.23,14.68c.21.11.46.18.71.18.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53c-.26,0-.5.06-.71.18v2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.95,10.49c.84,0,1.53-.68,1.53-1.53s-.66-1.5-1.48-1.52c-.35.92-.59,1.89-.7,2.9.2.09.42.15.65.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.7,5.94c.42-.24.72-.68.76-1.19-.28.38-.53.78-.76,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.1,3.96s.02,0,.03,0c.83,0,1.5-.66,1.52-1.48-.56.44-1.08.94-1.55,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.66,1.78c.84,0,1.53-.68,1.53-1.53,0-.09,0-.17-.02-.25-1.04.06-2.04.26-2.99.57.15.69.76,1.21,1.49,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.02,1.78c.73,0,1.34-.52,1.49-1.21-.95-.32-1.95-.51-2.99-.57-.01.08-.02.17-.02.25,0,.84.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.03,2.48c.02.82.7,1.48,1.52,1.48.01,0,.02,0,.03,0-.47-.54-.99-1.04-1.55-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.98,5.94c-.23-.41-.49-.81-.76-1.19.04.51.34.95.76,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.69,7.45c-.82.03-1.48.7-1.48,1.52s.68,1.53,1.53,1.53c.23,0,.45-.05.65-.15-.11-1.01-.35-1.98-.7-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.45,11.98c-.21-.11-.46-.18-.71-.18-.84,0-1.53.68-1.53,1.53s.68,1.53,1.53,1.53c.26,0,.5-.06.71-.18v-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.84,10.96c.6,0,1.12.36,1.36.87.1-.21.16-.44.16-.68,0-.84-.68-1.53-1.53-1.53s-1.53.68-1.53,1.53c0,.25.06.48.16.68.24-.51.76-.87,1.36-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,18.92h1.57c.38-.28.63-.73.63-1.23,0-.84-.68-1.53-1.53-1.53-.24,0-.47.06-.67.16v2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.76,18.92h1.57v-2.6c-.2-.1-.43-.16-.67-.16-.84,0-1.53.68-1.53,1.53,0,.51.25.95.63,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,12.47v2.23c.2.1.43.16.67.16.84,0,1.53-.68,1.53-1.53s-.68-1.53-1.53-1.53c-.27,0-.53.07-.75.2.05.15.08.31.08.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.66,14.85c.24,0,.47-.06.67-.16v-2.23c0-.16.03-.32.08-.47-.22-.12-.48-.2-.75-.2-.84,0-1.53.68-1.53,1.53s.68,1.53,1.53,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.68,18.92c-.28-.35-.71-.58-1.19-.58s-.91.23-1.19.58h2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.32,18.92c-.28-.35-.71-.58-1.19-.58s-.91.23-1.19.58h2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.41,18.92h1.79c.38-.28.63-.73.63-1.23,0-.84-.68-1.53-1.53-1.53s-1.53.68-1.53,1.53c0,.51.25.95.63,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.84,18.92c.38-.28.63-.72.63-1.23,0-.84-.68-1.53-1.53-1.53-.26,0-.5.06-.71.18v2.58h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.39,18.92c-.28-.35-.71-.58-1.19-.58s-.91.23-1.19.58h2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.75,18.92c-.28-.35-.71-.58-1.19-.58s-.91.23-1.19.58h2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.84,18.92h1.61v-2.58c-.21-.11-.46-.18-.71-.18-.84,0-1.53.68-1.53,1.53,0,.51.25.95.63,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.48,18.92h1.79c.38-.28.63-.73.63-1.23,0-.84-.68-1.53-1.53-1.53s-1.53.68-1.53,1.53c0,.51.25.95.63,1.23Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.84,46.8C8,46.8,0,38.8,0,28.96c0-.85.69-1.54,1.54-1.54s1.54.69,1.54,1.54c0,8.14,6.62,14.76,14.76,14.76s14.76-6.62,14.76-14.76c0-.85.69-1.54,1.54-1.54s1.54.69,1.54,1.54c0,9.84-8,17.84-17.84,17.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,21.93v18.6c5.7-.74,10.1-5.6,10.1-11.5v-7.1h-10.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.33,21.93H6.23v7.1c0,5.9,4.4,10.76,10.1,11.5v-18.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.86770b2e006a37a5ffe343390da43415.svg";
export { ForwardRef as ReactComponent };